<template>
  <footer class="app-footer">
    <a href="https://globalflow.com.vn/" target="_blank">@GlobalFlow Technologies</a>
    <span class="ml-auto">Version: 3.0.0</span>
  </footer>
</template>
<script>
export default {
  name: 'c-footer'
}
</script>



// WEBPACK FOOTER //
// src/components/layout/Footer.vue